import { render, staticRenderFns } from "./ModalRotinas.vue?vue&type=template&id=26a64f50&"
import script from "./ModalRotinas.vue?vue&type=script&lang=js&"
export * from "./ModalRotinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports